import React, { Component } from 'react'
import './PoweredBy.scss';

import geneHaasFoundationLogo from './../../img/sponsor-logos/genehaasfoundation_logo.png';
import mcmasterLogo from './../../img/sponsor-logos/mcmastersquare.png';
import mesLogo from './../../img/sponsor-logos/mes-logo.jpg';
import tektronixLogo from './../../img/sponsor-logos/tektronix-logo.png';


let sponsors = [
  {logo:mcmasterLogo,
    link:"https://www.eng.mcmaster.ca/",
    color:"rgb(94,22,51)",
    id:1},
  {logo:geneHaasFoundationLogo,
    link:"https://www.haascnc.com/index.html",
    color:"rgb(46,86,153)",
    id:2},
  {logo:mesLogo,
    link:"https://macengsociety.ca/",
    color:"rgb(166,151,106)",
    id:3},
  {logo:tektronixLogo,
    link:"https://www.tek.com/en",
    color:"rgb(209,73,67)",
    id:4},
]


export class PoweredBy extends Component {
  componentDidMount() {
    // Show the component as soon as it mounts
    setTimeout(() => {
      const container = document.getElementById("powered-by-container");
      if (container) {
        container.style.opacity = 1;
      }
      
      // Make all sponsor logos visible
      for (let i = 1; i <= sponsors.length; i++) {
        setTimeout(() => {
          const sponsor = document.getElementById(`powered-by-sponsor-${i}`);
          if (sponsor) {
            sponsor.style.opacity = '1';
          }
        }, 300 * i);
      }
    }, 500);
  }

  render() {
    return (
      <div id="powered-by-container">
        <div className="powered-by-title-container">
          <h1 className="powered-by-title">
            Powered By
          </h1>
        </div>
        
        <div className="powered-by-sponsors-container">
          {sponsors.map(sponsor => (
            <a 
              id={`powered-by-sponsor-${sponsor.id}`} 
              href={sponsor.link} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{borderColor:sponsor.color}}
              className="sponsor-logo-wrapper"
            >
              <img className="powered-by-sponsor-image" src={sponsor.logo} alt=""/>
            </a>
          ))}
        </div>

        <p className="powered-by-motto">
          We fail as a team. We succeed as a team.<br />
          We value learning and growing as a team above all else.
        </p>
      </div>
    )
  }
}

export default PoweredBy
